// eslint-disable-next-line
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import { api } from '../api';
import { OrderData } from '../types/order';

const initialState: OrderData = {
  goods: [],
  selected: [],
  maxTotal: 0,
  totalCount: 0,
  servicePrice: '',
  isPaymentPromo: false,
  isHight: false,
};

const OrderInfo = createSlice({
  name: 'order',
  initialState,
  reducers: {

    activatePromo(state, { payload }) {
      state.goods = state.goods.map((item) => {
          if(item.categoryId === payload) {
              return {
                  ...item,
                  isActivatePromo: !item.isActivatePromo
              };
          } 
          return item;
      });

      state.isPaymentPromo = state.goods.some((item) => {
        return state.selected.includes(item.categoryId) && item.isActivatePromo;
      });
    },

    increase(state, { payload }) {
      if(state.totalCount < state.maxTotal) {
        state.goods = state.goods.map((item) => {
          if (item.categoryId === payload) {
              if(item.count < item.maxCount) {
                  const newCount = item.count + 1;
                  state.totalCount = state.totalCount + 1;
                  return {
                      ...item,
                      count: newCount
                  };
              }
          } 
          return item;
        });

        if (!state.selected.includes(payload)) {
          state.selected.push(payload);
        }

        state.isPaymentPromo = state.goods.some((item) => {
          return state.selected.includes(item.categoryId) && item.isActivatePromo;
        });
      }
    },

    decrease(state, { payload }) {
      state.goods = state.goods.map((item) => {
        if(item.categoryId === payload) {
            const newCount = item.count - 1;
            state.totalCount = state.totalCount - 1;
            if(newCount === 0) {
              state.selected.splice(state.selected.indexOf(payload), 1);
            }
            return {
                ...item,
                count: newCount
            };
        } 
        return item;
      });

      state.isPaymentPromo = state.goods.some((item) => {
        return state.selected.includes(item.categoryId) && item.isActivatePromo;
      });
    },

    removing(state, { payload }) {
      state.goods = state.goods.map((item) => {
        if(item.categoryId === payload) {
            const newCount = 0;
            state.totalCount = state.totalCount - item.count;
            state.selected.splice(state.selected.indexOf(payload), 1);
            return {
                ...item,
                count: newCount
            };
        } 
        return item;
      });

      state.isPaymentPromo = state.goods.some((item) => {
        return state.selected.includes(item.categoryId) && item.isActivatePromo;
      });
    },

    //сюда проработанные функции добавления/удаления/увеличения/уменьшения билетов в заказе + пересчет количества и общей суммый заказа + в апи сделать графу сервисного сбора отдельно;
  },
  extraReducers: (builder) => {
    builder
    .addMatcher(
      api.endpoints.getProducts.matchFulfilled,
      (state, { payload }) => {
        // console.log(payload);
        if(payload.response === 'ok') {
          state.goods = payload.items;
          state.maxTotal = payload.maxTotal;
          state.servicePrice = payload.service;
          state.totalCount = payload.items.reduce((accumulator, item) => accumulator + item.count, 0);
          state.selected = payload.items.filter((item) => item.count > 0).map((item) => item.categoryId);
        } else if(payload.response === 'error') {
          window.parent.location.replace(payload.link);
        }
      }
    )
    .addMatcher(
      api.endpoints.sendContactInfo.matchFulfilled,
      (state, { payload }) => {
        if(payload.response === 'ok') {

          window.parent.postMessage({ event: 'bePaidPayment', ...payload }, '*');
          // console.log(payload);

        } 
      }
    )
    .addMatcher(
      api.endpoints.updateProducts.matchFulfilled,
        (state, { payload }) => {
          if(payload['response'] === 'ok') {
            state.goods = payload.items;
            state.totalCount = payload.items.reduce((accumulator, item) => accumulator + item.count, 0);
            state.selected = payload.items.filter((item) => item.count > 0).map((item) => item.categoryId);
            state.isHight = payload.hight;
          } else {
            state.goods = [];
            state.totalCount = 0;
            state.selected = [];
            state.isHight = payload.hight;
          }
          //console.log(payload);
        }
    )
  },
});

export const selectGoods = (state: RootState) => state.orderSlice.goods;
export const { activatePromo, increase, decrease, removing } = OrderInfo.actions;
export default OrderInfo.reducer;
